export const enAttente = "En attente";
export const enCours = "En cours";
export const completee = "Completee";